.Input {
  appearance: none;
  background: var(--background-surface-foundation-background-primary);
  border: 1px solid var(--border-foundation-border-primary);
  border-radius: var(--border-radius-md);
  font-size: var(--font-size-md);
  line-height: 1.5;
  padding: calc(var(--space-md) - var(--space-xxs)) var(--space-lg);
  transition: background-color 0.2s ease-in-out 0s,
    border-color 0.2s ease-in-out 0s;
  width: 100%;
}

.Input:disabled {
  background-color: var(--color-gray-50);
}

.Input:focus,
.Input:active {
  outline: 1px solid var(--border-foundation-border-selected);
}

.Input.isInvalid {
  border-color: var(--color-red-700);
}

.Input:not(:focus):hover {
  background-color: var(--color-gray-50);
}

.InputGroup {
  display: flex;
  isolation: isolate;
  position: relative;
  width: 100%;
}

.InputGroup .Input:not(:first-child) {
  padding-left: var(--space-5xl);
}

.InputGroup .Input:not(:last-child) {
  padding-right: var(--space-5xl);
}

.InputRightElement {
  align-items: center;
  bottom: 0;
  display: flex;
  justify-content: center;
  position: absolute;
  right: var(--space-lg);
  top: 0;
  z-index: 2;
}

.InputLeftElement {
  align-items: center;
  bottom: 0;
  display: flex;
  justify-content: center;
  left: var(--space-lg);
  position: absolute;
  top: 0;
  z-index: 2;
}
